import { useEffect, useRef } from "react";

import SpinnerIcon from "assets/icons/spinner.svg?react";
import css from "./loader.module.scss";

interface LoaderProps {
  /** Показывать процент загрузки (по умолчанию true — фейковый прогресс) */
  showProgress?: boolean;
}

export function Loader({ showProgress = true }: LoaderProps) {
  const progressRef = useRef(1);
  const ref = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const interval = showProgress
      ? setInterval(() => {
          progressRef.current += (100 - progressRef.current) * 0.1;
          if (ref.current) {
            ref.current.textContent = `${Math.floor(progressRef.current)}%`;
          }
        }, 40)
      : null;

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [showProgress]);

  return (
    <div className={css.container}>
      <SpinnerIcon />
      {showProgress && (
        <span className={css.progress} ref={ref}>
          1%
        </span>
      )}
    </div>
  );
}
